
import { Component, Prop, Vue, TSX } from 'vue-facing-decorator'
interface Props {
  modelValue?: any,
  pageName?: string
}
/**
 * 活动渲染模板的装修编辑器，作为 $dialog 的内容组件用。
 *
 * 和店铺装修共用 ui-custom：左边拖组件、中间手机预览、右边调配置，
 * 它自带的「保存」按钮就是本弹窗的确定键 —— emit resolve 把新模板交回调用方，
 * 右上角关闭走 $dialog 的 reject，调用方 catch 掉当取消。
 */
@Component({})
export default class extends TSX<Props>()(Vue) implements Props {
  @Prop({
    default() {
      return []
    }
  })
  modelValue: any[];

  @Prop()
  pageName: string;

  list: any[] = [];

  created() {
    /**
     * 必须深拷贝：ui-custom 内部只做 `{...item}` 浅拷贝，组件配置（item.data）还是同一个对象，
     * 直接传引用的话，在弹窗里改配置再点关闭，没保存的改动也已经落到表单上了。
     */
    this.list = Array.isArray(this.modelValue) ? JSON.parse(JSON.stringify(this.modelValue)) : [];
  }

  saveEvent(data: any) {
    this.$emit('resolve', data.list || []);
  }
}
